"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterEventsToProcess = exports.revertConflictingFields = exports.CONFLICTING_KEY_MAP = exports.groupEventsByOrderId = void 0;
const groupEventsByOrderId = (events) => {
    if (events.length === 0) {
        return {};
    }
    return events.reduce((acc, orderEvent) => {
        const { orderId } = orderEvent;
        return { ...acc, [orderId]: [...(acc[orderId] || []), orderEvent] };
    }, Object.create(null));
};
exports.groupEventsByOrderId = groupEventsByOrderId;
exports.CONFLICTING_KEY_MAP = {
    voidReason: 'reason',
    optionalVoidReason: 'reason',
    optionalReason: 'reason',
    rejectionReason: 'reason',
    optionalSeatNumber: 'seatNumber',
    optionalCustomerId: 'customerId',
    optionalOrderItemId: 'orderItemId',
    optionalPaymentRequestId: 'paymentRequestId',
    optionalPaymentStatus: 'paymentStatus',
};
const revertConflictingFields = (events) => {
    let textToModify = JSON.stringify(events);
    for (const key in exports.CONFLICTING_KEY_MAP) {
        textToModify = textToModify.replace(new RegExp(`"${key}":`, 'g'), `"${exports.CONFLICTING_KEY_MAP[key]}":`);
    }
    return JSON.parse(textToModify);
};
exports.revertConflictingFields = revertConflictingFields;
const filterEventsToProcess = (events, lastProcessedEvent) => {
    const nextEventToProcessIndex = events.findIndex(x => x.previous === lastProcessedEvent);
    if (nextEventToProcessIndex === -1)
        return [];
    return events.slice(nextEventToProcessIndex);
};
exports.filterEventsToProcess = filterEventsToProcess;
//# sourceMappingURL=eventHelper.js.map